module.exports = __webpack_public_path__ + "assets/img/1_594_big.c99d056a.jpg";